import React, { useEffect, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import {
  Cell,
  Label,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip
} from 'recharts'
import { useImmer } from 'use-immer'
import ShimmeringEffect from '../../components/shimmering/ShimmeringEffect'
import {
  CustomLabel,
  CustomizedLegend,
  replaceString
} from '../../lib/AllGlobalFunction'
import { isSellerPanel } from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'

const BrandChart = ({ values, setFieldValue }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useImmer({
    seller: {},
    sellerData: [],
    kyc: {},
    kycData: []
  })

  const getBrandColor = (key) => {
    let color = ''
    switch (key) {
      case 'active':
        color = '#d6fffd'
        break
      case 'inRequest':
        color = '#35afaa'
        break
      case 'inactive':
        color = '#42e1da'
        break
      default:
        break
    }
    return color
  }

  const fetchData = async (days = 'All') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: isSellerPanel
          ? 'Seller/Dashboard/getBrandCounts'
          : 'Dashboard/getBrandCounts',
        queryString: `?days=${days}`
      })
      setLoading(false)

      if (response?.status === 200) {
        let brand = response?.data?.data
        let brandData = Object.entries(brand).reduce((arr, [key, value]) => {
          if (key !== 'total') {
            arr.push({
              name: replaceString(key),
              value,
              color: getBrandColor(key)
            })
          }
          return arr
        }, [])

        setData((draft) => {
          draft.brand = brand
          draft.brandData = brandData
        })
      }
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return loading ? (
    <ShimmeringEffect />
  ) : (
    <div
      style={{ boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}
      className='pv-dashbord-chart-col pv-PieChart-main rounded h-100'
    >
      <Tabs defaultActiveKey='Brands' id='justify-tab-example' justify>
        <Tab className='border-0' eventKey='Brands' title='Brands'>
          <ResponsiveContainer
            className='pv-piechart-main'
            width='100%'
            height={140}
          >
            <PieChart>
              <Pie
                data={data?.brandData}
                dataKey='value'
                cx={'30%'}
                cy={60}
                innerRadius={0}
                outerRadius={100}
              >
                {data?.brandData?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
                <Label
                  content={
                    <CustomLabel
                      labelText='Total :'
                      value={data?.brand?.total}
                    />
                  }
                  position='center'
                />
              </Pie>
              <Tooltip />
              <Legend
                layout='vertical'
                verticalAlign='middle'
                align='left'
                content={<CustomizedLegend />}
              />
            </PieChart>
          </ResponsiveContainer>
        </Tab>
      </Tabs>
      <Dropdown className='pv-chartdash-dropbtn'>
        <Dropdown.Toggle className='btn-light' id='dropdown-basic'>
          {values?.brand ? values?.brand : 'All'}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              fetchData('All')
              setFieldValue('brand', 'All')
            }}
          >
            All
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              fetchData('Today')
              setFieldValue('brand', 'Today')
            }}
          >
            Today
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              fetchData('7')
              setFieldValue('brand', 'Last Week')
            }}
          >
            Last Week
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              fetchData('15')
              setFieldValue('brand', 'Last 15 Days')
            }}
          >
            Last 15 Days
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              fetchData('30')
              setFieldValue('brand', 'This Month')
            }}
          >
            This Month
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              fetchData('90')
              setFieldValue('brand', 'Last 3 Month')
            }}
          >
            Last 3 Month
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}

export default BrandChart
